import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Stkmm } from '../entity/Stkmm-angular';


@Injectable({
  providedIn: 'root'
})
export class StkmmServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = 'MM001=MJ001,MM002=MJ002';
    this.defaultItem = new Stkmm();
    this.entityType.type = EntityType.detail;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MM001: '帳號代號', MM002: '條件代號', MM003: '股票代號', MM004: '更新日期', MM005: '更新時間', MM006: '選擇', MM007: '說明'
    };

    this.fieldNames = 'MM001,MM002,MM003,MM004,MM005,MM006,MM007';
    this.fieldLengths = { MM001: 6, MM002: 6, MM003: 10, MM004: 8, MM005: 8, MM006: 1, MM007: 255 };
    this.columnDefs = [
      { field: "MM003", headerName: "股票代號", headerTooltip: "", width: 150, cellDataType: "text", },
      { field: "MM004", headerName: "更新日期", headerTooltip: "", width: 120, cellDataType: "text", valueFormatter: dateFormatter, },
      { field: "MM005", headerName: "更新時間", headerTooltip: "", width: 134, cellDataType: "text", },
      { field: "MM006", headerName: "選擇", headerTooltip: "", width: 80, cellDataType: "text", cellRenderer: AgCheckBoxEditor, },
      { field: "MM007", headerName: "說明", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
    ];
    this.columnDefsVir = [
      { field: "MM003C", headerName: "名稱", headerTooltip: "", width: 230, cellDataType: "text", },
    ];
    this.tableName = 'STKMM';
    this.isSys = false;
    this.sqlSelect = `SELECT STKMM.*,MA002 AS MM003C  FROM STKMM
LEFT JOIN STKMA ON MA001=MM003` ;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MM001,MM002`;
    this.keyFields = ['MM001', 'MM002', 'MM003', 'MM004'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MM001', 'MM002', 'MM003', 'MM004'];
    this.seqField = '';
    this.seqFieldLength = 4;
  }
  override async validateItem(item: Stkmm): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Stkmm): Promise<Stkmm> {
    await super.newRecord(newItem);
    return newItem;
  }



  async MM003Change(value: any) { // 股票代號
    let bool = await this.advCheck('MM003', this.item, 'STKMA', 'V01', 'MM003C', [this.item.MM003], 'E', '股票代號錯誤.');
  }

}

// 客製開始====================================================
